export default __webpack_public_path__ + "static/media/training@2x.979ce705.png";